import ColorSchemeApi from '@apis/colorScheme/ColorSchemeApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const colorSchemeQueries = createQueryKeys('colorScheme', {
    getColorScheme: () => ({
        queryKey: ['getColorScheme'],
        queryFn: () => ColorSchemeApi.getColorScheme(),
    }),
});

export default colorSchemeQueries;
